import './about.css';

import SkillScroller from '../SkillScroller/SkillScroller';
import { useDatabase } from '../../hooks/useDatabase';

import { MdOutlineCloudDownload } from "react-icons/md";

export default function About() {
    const db = useDatabase();

    return (
        <section className="about-panel" id="about">
            <div className="inner">
                <h2>About</h2>

                <div className="cols">
                    <div className="col about-content">
                        <div className="white-box">
                            <div dangerouslySetInnerHTML={ { __html: db.sections.hero.content }}></div>
                            <a className="btn btn-icon" href="/callum-tanner.pdf" target="_blank">Download CV <MdOutlineCloudDownload fontWeight={800} /></a>
                        </div>
                    </div>
                </div>

                <SkillScroller />
            </div>
        </section>
    );
}